export default __webpack_public_path__ + "static/media/pause.bd347114.svg";